import React, { Component } from 'react';

class DragAndDrop extends Component {

  constructor(props) {
    super(props);
    this.state = {
      drag: false,
    }
  }

  handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
  }

  handleDragIn = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.dragCounter++;
    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      this.setState({ drag: true });
    }
  }

  handleDragOut = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.dragCounter--;
    if (this.dragCounter === 0) {
      this.setState({ drag: false });
    }
  }

  handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ drag: false });
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      this.props.handleDrop(e.dataTransfer.files);
      e.dataTransfer.clearData();
      this.dragCounter = 0;
    }
  }

  componentDidMount() {
    let div = this.dragComp;
    div.addEventListener('dragenter', this.handleDragIn);
    div.addEventListener('dragleave', this.handleDragOut);
    div.addEventListener('dragover', this.handleDrag);
    div.addEventListener('drop', this.handleDrop);
  }

  componentWillUnmount() {
    let div = this.dragComp;
    div.removeEventListener('dragenter', this.handleDragIn);
    div.removeEventListener('dragleave', this.handleDragOut);
    div.removeEventListener('dragover', this.handleDrag);
    div.removeEventListener('drop', this.handleDrop);
  }

  render() {
    return (
      <div
        style={{ position: 'relative' }}
        ref={(node) => { this.dragComp = node; }}
      >
        <div
          style={{
            border: 'dashed grey 4px',
            backgroundColor: 'rgba(255,255,255,.8)',
            position: 'relative',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 9999,
            width: '100%',
            height: '150px',
            marginBottom: '20px',
            opacity: this.state.drag ? 1 : 0.5,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '5px 10px'
          }}
        >
          <div
            style={{
              color: 'grey',
              fontSize: 36
            }}
          >
            <div>Drag and Drop Files here to Upload.</div>
          </div>
        </div>
        {this.props.children}
      </div>
    )
  }
}

export default DragAndDrop;



// WEBPACK FOOTER //
// ./src/common/DragAndDrop/index.js